export default __webpack_public_path__ + "static/screeny-110-gpz-unica-am-5-656ee99f1fbf11ed30c2d380d44ea3c2.jpg";